import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function ReportFieldInput({ field, value, onChange, disabled }) {
  const tid = `report-field-${field.key}`;
  const v = value ?? "";
  let control;
  if (field.type === "textarea") {
    control = <Textarea rows={3} value={v} disabled={disabled} onChange={e => onChange(e.target.value)} data-testid={tid} placeholder={field.help || ""} />;
  } else if (field.type === "yesno") {
    control = (
      <div className="flex gap-1.5" data-testid={tid}>
        {["yes", "no"].map(o => (
          <button key={o} type="button" disabled={disabled} onClick={() => onChange(o)} data-testid={`${tid}-${o}`}
            className={`px-4 py-1.5 rounded text-[10px] tracking-widest uppercase border ${v === o ? "bg-[#83B68B] text-white border-[#83B68B]" : "border-border opacity-70 hover:opacity-100"}`}>{o}</button>
        ))}
      </div>
    );
  } else if (field.type === "choice") {
    control = (
      <Select value={v} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger data-testid={tid}><SelectValue placeholder="Select…" /></SelectTrigger>
        <SelectContent>{(field.options || []).map(o => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
      </Select>
    );
  } else {
    control = <Input type={field.type === "date" ? "date" : field.type === "time" ? "time" : "text"} value={v} disabled={disabled} onChange={e => onChange(e.target.value)} data-testid={tid} placeholder={field.type === "text" ? (field.help || "") : undefined} />;
  }
  return (
    <div className={field.type === "textarea" ? "sm:col-span-2" : ""}>
      <Label className="text-[10px] tracking-widest uppercase opacity-70">{field.label} {field.required && <span className="text-[#83B68B]">*</span>}</Label>
      <div className="mt-1.5">{control}</div>
      {field.help && field.type !== "text" && field.type !== "textarea" && <div className="text-[10px] opacity-50 mt-1">{field.help}</div>}
    </div>
  );
}

export function displayValue(field, v) {
  if (v === null || v === undefined || v === "") return "—";
  if (field.type === "yesno") return v === "yes" || v === true ? "Yes" : "No";
  return String(v);
}
